export class Constants {
    public static STRIPE_ONBOARDING_COMPONENT: string = "account-onboarding";
}